import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

import { environment } from 'environments/environment';
import { FeatureFlag, featureIsEnabled } from './feature-flag';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  /**
   * Returns whether a feature is enabled
   */
  isEnabled = featureIsEnabled;

  constructor() {}

  detectFeatures() {
    const queryParams: {
      [key: string]: string | undefined;
    } = {};

    const [hostAndPath, querystring] = location.href.split('?');
    if (querystring) {
      querystring.split(/&/g).forEach(pair => {
        const [key, value] = pair.split(/=/);
        queryParams[key.toUpperCase()] = value;
      });

      let hasFeatureParams = false;

      (Object.keys(FeatureFlag) as Array<keyof typeof FeatureFlag>).forEach(feature => {
        const queryValue = queryParams[feature.toUpperCase()];

        if (queryValue != null) {
          hasFeatureParams = true;
          if (queryValue && queryValue !== '0' && queryValue !== 'false') {
            localStorage.setItem(feature, 'true');
          } else {
            localStorage.removeItem(feature);
          }
        }
      });

      if (hasFeatureParams) {
        location.replace(hostAndPath);
      }
    }
  }

  outputFeatures() {
    const urlWithoutHash = location.href.split('#')[0];
    const baseUrl = urlWithoutHash + (/\?/.test(urlWithoutHash) ? '&' : '?');

    const features = Object.values(FeatureFlag);

    if (features.length > 0) {
      console.group('Experimental features');
      if (!environment.production) {
        console.log('Character check: \u2610\u2611\u2612\u2713\u2714\u2715\u2716\u2717\u2718');
      }
      const maxLength = features.reduce((max, f) => Math.max(max, f.length), 0);
      features.forEach(feature => {
        const prefix = 'padEnd' in String.prototype ? `${feature}`.padEnd(maxLength) : feature;
        if (this.isEnabled(feature)) {
          console.log(`\u2611 ${prefix}   DISABLE ➡ ${baseUrl}${feature}=0`);
        } else {
          console.log(`\u2610 ${prefix}   ENABLE  ➡ ${baseUrl}${feature}=1`);
        }
      });
      console.groupEnd();
    }
  }

  getQueryParams() {
    const queryParams: Params = {};
    Object.values(FeatureFlag).forEach(key => {
      if (this.isEnabled(key)) {
        queryParams[FeatureFlag[key]] = true;
      }
    });

    return queryParams;
  }
}
